export var ReportBuilderTab;
(function (ReportBuilderTab) {
    ReportBuilderTab["PAGE_PREVIEW"] = "page_preview";
    ReportBuilderTab["MODULE_MENU"] = "module_menu";
    ReportBuilderTab["SETTINGS"] = "settings";
})(ReportBuilderTab || (ReportBuilderTab = {}));
export var ReportBuilderModuleMenuSubTab;
(function (ReportBuilderModuleMenuSubTab) {
    ReportBuilderModuleMenuSubTab["MODULES"] = "modules";
    ReportBuilderModuleMenuSubTab["EDIT"] = "edit";
})(ReportBuilderModuleMenuSubTab || (ReportBuilderModuleMenuSubTab = {}));
